import {
  KybPersonCandidate,
  KybRelationRole,
  KybRelationScreen,
} from "./KybRepresentative";

const ALL_ROLES: KybRelationRole[] = [
  {
    code: "13",
    label: "PDG",
    category: "DIRIGEANT",
    categoryLabel: "Dirigeant / mandataire social",
    relatedPartyNature: "PP",
  },
  {
    code: "14",
    label: "Directeur Général",
    category: "DIRIGEANT",
    categoryLabel: "Dirigeant / mandataire social",
    relatedPartyNature: "PP",
  },
  {
    code: "15",
    label: "Gérant",
    category: "DIRIGEANT",
    categoryLabel: "Dirigeant / mandataire social",
    relatedPartyNature: "PP",
  },
  {
    code: "20",
    label: "Signataire autorisé",
    category: "SIGNATAIRE",
    categoryLabel: "Signataire",
    relatedPartyNature: "PP",
  },
  {
    code: "30",
    label: "Actionnaire",
    category: "DETENTION",
    categoryLabel: "Détention",
    relatedPartyNature: "PP_PM",
  },
];

/** Rôles proposables sur l'écran donné, calqué sur `KybRelationRoleCatalogUseCase.selectableRolesFor`. */
export function generateMockRelationRoles(
  ecran?: KybRelationScreen,
): KybRelationRole[] {
  if (!ecran) {
    return ALL_ROLES;
  }
  return ALL_ROLES.filter((role) =>
    ecran === "REPRESENTANTS"
      ? role.category === "DIRIGEANT" || role.category === "SIGNATAIRE"
      : role.category === "DETENTION" || role.category === "BENEFICIAIRE_EFFECTIF",
  );
}

/** Pas de doublon en mode mock : le repli mock reste "toujours réussir", cohérent avec le reste du repository. */
export function generateMockRepresentativeCandidates(): KybPersonCandidate[] {
  return [];
}
